import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { complaintFeedbackList } from "../apis/apiHandler";

export const complaintFeedback = createAsyncThunk(
    "complaint_feedback/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await complaintFeedbackList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    complaintFeedbackList: [],
    error: null,
    success: false,
};

const complaintFeedbackSlice = createSlice({
    name: "complaint feedback",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(complaintFeedback.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(complaintFeedback.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.complaintFeedbackList = payload;
                state.success = true;
            })
            .addCase(complaintFeedback.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default complaintFeedbackSlice.reducer;